// Value Prop Carousel Components
// Depends on window.Splide (exposed from legacy-global.js)

if (!customElements.get('value-prop-stats-carousel')) {
  customElements.define(
    'value-prop-stats-carousel',
    class ValuePropStatsCarousel extends HTMLElement {
      constructor() {
        super();
        this.autoplayInterval = parseInt(this.dataset.autoplayInterval) || 4;
        this.carousel = null;
      }

      connectedCallback() {
        this.generateCarousel();
      }

      generateCarousel() {
        const Splide = window.Splide;

        // Store the slides
        const originalList = this.querySelector('.splide__list');
        const slides = originalList ? originalList.innerHTML : this.innerHTML;

        // Clear content
        this.innerHTML = '';

        // Create the splide container
        const splideContainer = document.createElement('div');
        splideContainer.classList.add('splide');

        // Create track and list
        const track = document.createElement('div');
        track.classList.add('splide__track');

        const list = document.createElement('div');
        list.classList.add('splide__list');

        // Add slides to list
        list.innerHTML = slides;

        // Build structure
        track.append(list);
        splideContainer.append(track);
        this.append(splideContainer);

        // Initialize carousel
        this.carousel = new Splide(splideContainer, {
          type: 'loop',
          rewind: true,
          perPage: 1,
          perMove: 1,
          arrows: false,
          pagination: true,
          autoplay: true,
          interval: this.autoplayInterval * 1000,
          pauseOnHover: true,
          pauseOnFocus: true,
          drag: true,
          classes: {
            pagination: 'splide__pagination relative mt-6 mb-8 flex justify-start',
            page: 'splide__pagination__page'
          }
        });

        // Sync with other carousels after all are initialized
        setTimeout(() => {
          this.syncCarousels();
        }, 100);

        // Add role to slides for accessibility
        const slideElements = splideContainer.querySelectorAll('.splide__slide');
        slideElements.forEach((slide, index) => {
          slide.setAttribute('role', 'tabpanel');
          slide.setAttribute('aria-label', `Slide ${index + 1} of ${slideElements.length}`);
        });
      }

      syncCarousels() {
        // Find other carousels
        const imageCarousel = document.querySelector('value-prop-image-slider');
        const disclaimerCarousels = document.querySelectorAll('value-prop-disclaimer-carousel');

        // Sync all carousels
        if (imageCarousel && imageCarousel.carousel) {
          this.carousel.sync(imageCarousel.carousel);
        }

        disclaimerCarousels.forEach((disclaimerEl) => {
          if (disclaimerEl.carousel) {
            this.carousel.sync(disclaimerEl.carousel);
          }
        });

        // Mount after syncing
        this.carousel.mount();
      }
    }
  );
}

if (!customElements.get('value-prop-image-slider')) {
  customElements.define(
    'value-prop-image-slider',
    class ValuePropImageSlider extends HTMLElement {
      constructor() {
        super();
        this.carousel = null;
      }

      connectedCallback() {
        this.generateImageCarousel();
      }

      generateImageCarousel() {
        const Splide = window.Splide;

        // Store the slides
        const originalList = this.querySelector('.splide__list');
        const slides = originalList ? originalList.innerHTML : this.innerHTML;

        // Clear content
        this.innerHTML = '';

        // Create the splide container
        const splideContainer = document.createElement('div');
        splideContainer.classList.add('splide');

        // Create track and list
        const track = document.createElement('div');
        track.classList.add('splide__track');

        const list = document.createElement('div');
        list.classList.add('splide__list');

        // Add slides to list
        list.innerHTML = slides;

        // Build structure
        track.append(list);
        splideContainer.append(track);
        this.append(splideContainer);

        // Initialize image carousel (no autoplay, no pagination)
        this.carousel = new Splide(splideContainer, {
          type: 'loop',
          rewind: true,
          perPage: 1,
          perMove: 1,
          arrows: false,
          pagination: false,
          autoplay: false,
          drag: false
        });

        // Mount the image carousel
        this.carousel.mount();
      }
    }
  );
}

if (!customElements.get('value-prop-disclaimer-carousel')) {
  customElements.define(
    'value-prop-disclaimer-carousel',
    class ValuePropDisclaimerCarousel extends HTMLElement {
      constructor() {
        super();
        this.carousel = null;
      }

      connectedCallback() {
        this.generateCarousel();
      }

      generateCarousel() {
        const Splide = window.Splide;

        // Store the slides
        const originalList = this.querySelector('.splide__list');
        const slides = originalList ? originalList.innerHTML : this.innerHTML;

        // Clear content
        this.innerHTML = '';

        // Create the splide container
        const splideContainer = document.createElement('div');
        splideContainer.classList.add('splide');

        // Create track and list
        const track = document.createElement('div');
        track.classList.add('splide__track');

        const list = document.createElement('div');
        list.classList.add('splide__list');

        // Add slides to list
        list.innerHTML = slides;

        // Build structure
        track.append(list);
        splideContainer.append(track);
        this.append(splideContainer);

        // Initialize carousel (no autoplay, no pagination)
        this.carousel = new Splide(splideContainer, {
          type: 'loop',
          rewind: true,
          perPage: 1,
          perMove: 1,
          arrows: false,
          pagination: false,
          autoplay: false,
          drag: false
        });

        // Mount immediately
        this.carousel.mount();
      }
    }
  );
}
